import { useAjax, useMzQuery } from "@bsm/component";

export const useShoolYearsQuery = () => {
    const ajax = useAjax();
    return useMzQuery('Bsm.Scholarity.SchoolYears.Query', async () => {
        return await ajax.send({
            type: "GET",
            url: `student/scholarity/school-years`,
            content_type: "application/json",
            data_type: 'application/json'
        })
    }, { suspense: true })
};
